import { render } from "./InformeGremiosExpediente.vue?vue&type=template&id=fa9a9dce&scoped=true"
import script from "./InformeGremiosExpediente.vue?vue&type=script&lang=js"
export * from "./InformeGremiosExpediente.vue?vue&type=script&lang=js"

import "./InformeGremiosExpediente.vue?vue&type=style&index=0&id=fa9a9dce&scoped=true&lang=css"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa9a9dce"]])

export default __exports__